import { render, staticRenderFns } from "./CampaignFormatSettings.vue?vue&type=template&id=4975d094&scoped=true&"
import script from "./CampaignFormatSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignFormatSettings.vue?vue&type=script&lang=js&"
import style0 from "./CampaignFormatSettings.vue?vue&type=style&index=0&id=4975d094&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975d094",
  null
  
)

export default component.exports